<template>
  <div
    class="mt-6 flex justify-start items-start flex-col w-full h-auto bg-transparent overflow-visible"
  >
    <report-selector label="Inventories" v-model="selection">
      <option v-for="i in inventoriesOrdered" :key="i.id" :value="i.id">
        {{
          `${Date.prototype.toDateString.call(
            i.date.toDate()
          )} @ ${Date.prototype.toLocaleTimeString.call(i.date.toDate())}${
            'completed' in i ? (i.completed ? '' : ' (incomplete)') : ''
          }`
        }}
      </option>
    </report-selector>

    <div v-if="doc" class="relative mt-3">
      <s-button class="shadow-lg" @click.stop="actionsOpen = !actionsOpen">
        Actions
      </s-button>
      <div
        v-if="actionsOpen"
        class="absolute left-0 mt-1 w-52 bg-white rounded-lg shadow-lg py-1 z-50 border border-gray-200"
      >
        <button
          v-if="isAdmin || isManager"
          @click="downloadCsv(reportCSV); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Export
        </button>
        <button
          v-if="isAdmin || isManager"
          @click="downloadDetailedCsv(); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Detailed Export
        </button>
        <button
          v-if="isAdmin"
          @click="fixPastInventoryProductPrices(selection); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Fix Usage
        </button>
        <button
          v-if="isAdmin"
          class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
    <div v-if="actionsOpen" class="fixed inset-0 z-40" @click="actionsOpen = false" />

    <report-table v-if="doc">
      <div>
        <table
          class="text-left w-full border-collapse overflow-scroll leading-none"
        >
          <thead>
            <tr>
              <th
                v-for="(i, index) in [
                  'Product',
                  'Usage',
                  'Cost History',
                  'Category',
                  'Vendor',
                  'Code',
                  'Order Unit',
                  'Counting Unit',
                  'Each',
                  '',
                  'Price',
                  'Count',
                  'Value'
                ]"
                :key="i"
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-lg text-gray-800"
                :class="
                  index > 7 || index === 1 || index === 2
                    ? 'text-center'
                    : 'text-left'
                "
              >
                {{ i }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="i in reportArray"
              :key="`${i.productId}-reportOrderItem`"
              class="px-2 hover:bg-gray-100 hover:font-bold"
            >
              <td
                class="py-1 px-2 border-b"
                @click="
                  $modal.show('modal--product-prices', { id: i.productId })
                "
              >
                {{ i.name }}
              </td>
              <td class="py-1 px-2 text-center border-b">
                {{ i.unitsUsed }}
              </td>
              <td
                class="px-auto border-b"
                @click="
                  $modal.show('modal--product-prices', { id: i.productId })
                "
              >
                <sparkline
                  v-if="
                    productsCosts[i.productId] &&
                      productsCosts[i.productId].length > 1
                  "
                  :data="[
                    ...productsCosts[i.productId].map(dataPoint =>
                      Math.abs(dataPoint.cost).toFixed(2)
                    )
                  ]"
                ></sparkline>
              </td>
              <td class="py-1 px-2 border-b">
                {{ i.category }}
              </td>
              <td class="py-1 px-2 border-b">
                {{ i.vendor }}
              </td>
              <td class="py-1 px-2 border-b">
                {{ i.code }}
              </td>
              <td class="py-1 px-2 border-b">
                {{ i.unitOrdering }}
              </td>
              <td class="py-1 px-2 border-b">
                {{ i.unitCounting }}
              </td>
              <td class="py-1 px-2 border-b text-left whitesapce-no-wrap">
                {{ i.each ? format(i.each) : '' }}
              </td>
              <td class="py-1 px-2 border-b text-center whitespace-nowrap">
                {{ `x ${i.qtyPerUnit}` }}
              </td>
              <td
                class="py-1 px-2 bg-yellow-200 focus-within:bg-yellow-300 border-b whitesapce-no-wrap"
              >
                <!-- <input
                  type="number"
                  class="text-center w-16 bg-transparent no-arrow"
                  :value="i.price"
                  @change="
                    e =>
                      updatePriceByInventoryIdByProductId({
                        inventoryId: selection,
                        id: i.productId,
                        price: e.target.valueAsNumber
                      })
                  "
                /> -->
                <money
                  class="w-16 text-center bg-transparent no-arrow"
                  v-model.lazy="i.price"
                  @change.native="
                    e => {
                      if (e.isTrusted)
                        updatePriceByInventoryIdByProductId({
                          inventoryId: selection,
                          id: i.productId,
                          price: i.price
                        })
                    }
                  "
                  v-bind="moneyConfig"
                  autocomplete="off"
                />
              </td>
              <td
                class="py-1 px-2 bg-yellow-200 focus-within:bg-yellow-300 border-b font-bold"
              >
                <!-- {{ i.amountEntered }} -->
                <input
                  type="number"
                  min="0"
                  class="text-center w-16 bg-transparent"
                  :value="i.amountEntered"
                  @change="
                    e =>
                      updateAmountEnteredByInventoryIdByProductId({
                        inventoryId: selection,
                        id: i.productId,
                        amount: e.target.valueAsNumber
                      })
                  "
                />
              </td>
              <td class="py-1 px-2 border-b text-center font-bold">
                {{ i.value | usd }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </report-table>
    <div v-if="doc" class="w-full mt-3 mr-2 text-right flex flex-row text-base">
      <span class="flex-grow font-bold">
        <div v-for="(value, key) in categoryTotals" :key="key">
          {{ key | capitalize }}:
        </div>
      </span>
      <span class="mx-6 whitesapce-no-wrap">
        <div v-for="(value, key) in categoryTotals" :key="key + value">
          {{ value | usd }}
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import SButton from '@/components/Button'
import { mapActions, mapGetters } from 'vuex'
import { floatify, format } from '@/utils'
import ReportSelector from '@/components/ReportSelector'
import ReportTable from '@/components/ReportTable'
import Sparkline from '@/components/Sparkline'
import { Money } from 'v-money'

export default {
  name: 'ReportsInventories',
  data() {
    return {
      selection: null,
      actionsOpen: false,
      moneyConfig: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  components: {
    ReportSelector,
    ReportTable,
    Sparkline,
    SButton,
    Money
  },
  computed: {
    ...mapGetters('user', ['isAdmin', 'isManager']),
    ...mapGetters('storeModule', ['dailyOrdering', 'productPriceByProductId']),
    ...mapGetters('storeModule/inventories', [
      'inventoriesOrdered',
      'inventoryById',
      'inventoryCsvByInventoryId',
      'detailedInventoryCsvByInventoryId'
    ]),
    ...mapGetters('storeModule/products', ['products']),
    ...mapGetters('storeModule/invoices', ['productsCosts']),
    ...mapGetters('storeModule/vendors', ['vendors']),

    doc() {
      return this.inventoryById(this.selection)
    },
    // sortedDocProducts() {
    //   if (!this.doc) return null
    //   return Object.keys(this.doc)
    //     .filter(key => !!this.products[key])
    //     .map(productId => {
    //       return {
    //         productId,
    //         orderIndex: this.dailyOrdering.findIndex(a => a === productId)
    //       }
    //     })
    //     .sort((a, b) => {
    //       return a.orderIndex - b.orderIndex
    //     })
    // },

    categoryTotals() {
      let output = { ['Total Inventory Value']: 0 }

      this.reportArray.forEach(item => {
        if (
          Object.prototype.hasOwnProperty.call(item, 'category') &&
          Object.prototype.hasOwnProperty.call(item, 'value') &&
          typeof item.value === 'number' &&
          !isNaN(item.value)
        ) {
          if (!Object.prototype.hasOwnProperty.call(output, item.category))
            output[item.category] = 0
          output[item.category] += item.value
          output['Total Inventory Value'] += item.value
        }
      })

      Object.keys(output).forEach(key => (output[key] = floatify(output[key])))
      return output
    },
    reportCSV() {
      if (!this.doc) return null

      // convert reportArray to CSV
      let output =
        'Product;Category;Unit Counting;Each;Qty Per Unit;Price;Amount Entered;Value\n'
      this.reportArray.forEach(item => {
        output += `${item.name};${item.category};${item.unitCounting};${
          item.each
        };${item.qtyPerUnit};${item.price};${item.amountEntered};${
          item.value
        }\n`
      })
      return output
    },
    reportArray() {
      let data = []
      if (this.selection)
        Object.entries(this.doc).forEach(entry => {
          let productId = entry[0]

          if (this.products[productId]) {
            //
            // variables from inventory: price, amountEntered, unitsUsed
            // variables from database: qtyPerUnit
            // calculate: value, each
            //
            // each = price / qtyPerUnit
            // value = price x amountEntered
            //

            let price = ''
            let amountEntered = ''
            let unitsUsed = ''
            let qtyPerUnit = this.products[productId].qtyPerUnit
            let each = ''
            let value = ''

            try {
              price = floatify(entry[1].price)
              amountEntered = entry[1].amount
              unitsUsed = entry[1].unitsUsed
              if (typeof price == 'number' && !isNaN(price)) {
                each = floatify(price / qtyPerUnit)
                value = floatify(each * amountEntered)
              } else {
                price = ''
              }
            } catch {
              console.log('No price listed for product ', productId)
            }

            let category = [
              // 'protein',
              // 'produce',
              // 'pantry',
              // 'desert',
              // 'beverage',
              // 'desserts', // to delete
              // 'dry goods', // to delete
              // 'frozen', // to delete
              // 'dairy', // to delete
              // 'alcohol', // to delete
              '5210 Baked Goods',
              '5220 Beverages',
              '5232 Pantry',
              '5233 Fruits and Vegetables',
              '5241 Beef',
              '5242 Chicken',
              '5243 Eggs',
              '5244 Pork',
              '5245 Tofu'
              //'5410 Cleaning',
              //'5420 Disposables',
              //'5430 Kitchen',
              //'5440 Office',
            ].includes(this.products[productId].category)
              ? 'food'
              : 'other'

            data.push({
              productId,
              category,
              name: this.products[productId].name,
              unitsUsed,
              vendor: this.vendors[this.products[productId].vendor] ? this.vendors[this.products[productId].vendor].name : 'Unknown Vendor',
              code: this.products[productId].code,
              unitCounting: this.products[productId].unitCounting,
              unitOrdering: this.products[productId].unit,
              qtyPerUnit,
              price,
              value,
              each,
              amountEntered
              // orderIndex: this.dailyOrdering.findIndex(x => x === productId)
            })
          }
        })

      data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        // return a.orderIndex - b.orderIndex
      })
      return data
    }
  },
  methods: {
    downloadCsv(data = null) {
      if (!data) return
      let date = this.doc.date.toDate()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let dateString = `${year}${month < 10 ? '0' + month : month}${
        day < 10 ? '0' + day : day
      }`
      var hiddenElement = document.createElement('a')
      // critical to use encodeURIComponent instead of just encodeURI for # signs
      hiddenElement.href =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(data)
      hiddenElement.target = '_blank'
      hiddenElement.download = `${dateString}.csv`
      hiddenElement.click()
      hiddenElement.remove()
    },
    downloadDetailedCsv() {
      if (!this.selection) return
      try {
        const csvData = this.detailedInventoryCsvByInventoryId(this.selection)
        var hiddenElement = document.createElement('a')
        hiddenElement.href =
          'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData.data)
        hiddenElement.target = '_blank'
        hiddenElement.download = csvData.filename
        hiddenElement.click()
        hiddenElement.remove()
      } catch (error) {
        console.error('Error generating detailed CSV:', error)
      }
    },
    format,
    ...mapActions('storeModule/inventories', [
      'updatePriceByInventoryIdByProductId',
      'updateAmountEnteredByInventoryIdByProductId'
    ]),
    ...mapActions('storeModule', ['fixPastInventoryProductPrices']),
    fixDeadInventoryPrices() {
      this.reportArray.forEach(item => {
        if (!item.price || item.price == 0) {
          let productPrice = this.productPriceByProductId(item.productId)

          if (
            productPrice &&
            Object.prototype.hasOwnProperty.call(productPrice, 'cost')
          ) {
            this.updatePriceByInventoryIdByProductId({
              inventoryId: this.selection,
              id: item.productId,
              price: productPrice.cost
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}
.expand-enter-active {
  /* overflow: hidden; */
  transition: height 0.25s 0.1s ease-out, opacity 0.2s 0.2s ease-out;
  /* //if multiple expands, use this one */
  /* //transition: height 0.25s 0.3s ease-out, opacity 0.3s 0.5s ease-out; */
}
.expand-leave-active {
  /* overflow: hidden; */
  /* //if multiple expands, use this one */
  transition: opacity 0.05s ease-out, height 0.2s 0.1s ease-in;
}
</style>
